import { Button, Flex, Stack, TextInput } from "@mantine/core";
import { CloseOutlined, SearchOutlined, UploadOutlined } from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
import { FC } from "react";
import { FileFilterButton, FileFilterPills } from "./FileFilters";
import { FileFilterState } from "./useFileFilters";

type FileHeaderProps = {
    search: string;
    setSearch: (search: string) => void;
    filters: FileFilterState;
    setFilters: (filters: FileFilterState) => void;
    onUpload: () => void;
};

export const FileHeader: FC<FileHeaderProps> = ({
    search,
    setSearch,
    filters,
    setFilters,
    onUpload
}) => {
    return (
        <Stack gap="xs">
            <Flex justify="space-between" align="center">
                <Flex flex={1} gap="sm" align="center">
                    <TextInput
                        data-testid="search.bar.input"
                        placeholder="Search files..."
                        leftSection={<SvgIcon component={SearchOutlined} />}
                        value={search}
                        onChange={(e) => setSearch(e.currentTarget.value)}
                        rightSection={
                            search ? (
                                <SvgIcon
                                    component={CloseOutlined}
                                    sx={{
                                        width: "0.9rem",
                                        height: "0.9rem",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => setSearch("")}
                                />
                            ) : null
                        }
                    />
                    <FileFilterButton
                        filters={filters}
                        setFilters={setFilters}
                    />
                </Flex>
                <Flex flex={1} justify="flex-end">
                    <Button
                        leftSection={<SvgIcon component={UploadOutlined} />}
                        onClick={onUpload}
                    >
                        Upload File
                    </Button>
                </Flex>
            </Flex>
            <FileFilterPills filters={filters} setFilters={setFilters} />
        </Stack>
    );
};
